<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">旺旺打标工具</span>
      </div>
      <div>
        <el-row :gutter="10">
          <el-col :span="24">
          <span style="color: red;font-size: smaller">
            推客欢迎你使用淘宝工具，如遇到问题， 请联系客服。
          </span>
          </el-col>
        </el-row>

        <el-row :gutter="10" style="margin-top: 2%;">
          <el-col :span="24">
            <el-form ref="dbFormData" :model="dbFormData" label-width="100px">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="商品ID" prop="goodId">
                    <el-input v-model="dbFormData.goodId" placeholder="商品Id"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="关键字" prop="keyword">
                    <el-input v-model="dbFormData.keyword" placeholder="关键字"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="淘宝昵称" prop="nickName">
                    <el-input v-model="dbFormData.nickName" placeholder="淘宝昵称"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" style="text-align: center">
                <el-col :span="12">
                  <el-button type="primary" @click="confirmDb">确认打标</el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import {alitaobaoDbiao} from "@/api/b2cbusiness/b2c_tasklist";

export default {
   name: "AliTaobaoDbTool",
   data(){
     return {
       dbFormData:{}
     }
   },
  methods:{
    confirmDb(){
      alitaobaoDbiao(this.dbFormData).then(res=>{
        if (res.success){
          this.$message.success(res.data)
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style scoped>

</style>
